import { PaymentMethodType, Task } from '@admiin-com/ds-graphql';
import {
  WBButton,
  WBFlex,
  WBStack,
  WBSvgIcon,
  WBTypography,
} from '@admiin-com/ds-web';
import {
  usePaymentContext,
  usePaymentContextDetail,
} from '../../../../components/PaymentContainer/PaymentContainer';
import PaymentDetail from '../../../../components/PaymentDetail/PaymentDetail';
import AdmiinLogo from '../../../../../assets/icons/admiin.svg';
import { useTranslation } from 'react-i18next';
import React from 'react';
export const PaymentForm = ({ tasks }: { tasks: Task[] }) => {
  const { onSubmit, loading } = usePaymentContext();
  const bulkData = tasks.length > 1 ? tasks : undefined;
  const task = tasks.length === 1 ? tasks[0] : null;
  const { t } = useTranslation();
  const { paymentMethod } = usePaymentContextDetail(task ?? null);

  return (
    <WBFlex flexDirection={'column'} gap={2} flex={1}>
      <WBStack
        spacing={{ xs: 1, sm: 2 }}
        alignItems={'center'}
        direction={'row'}
      >
        <PaymentDetail bulkData={bulkData} task={task} type="Method">
          <PaymentDetail.Selector fontWeight="medium" />
        </PaymentDetail>
        <PaymentDetail bulkData={bulkData} task={task} type="Type">
          <PaymentDetail.Selector fontWeight="medium" />
        </PaymentDetail>
      </WBStack>
      <WBButton
        onClick={() => {
          onSubmit();
        }}
        loading={loading}
        sx={{
          fontSize: '18px',
        }}
        fullWidth
      >
        <WBSvgIcon fontSize="small" sx={{ mr: 1 }}>
          <AdmiinLogo />
        </WBSvgIcon>
        {t('PAY', { ns: 'payment' })}
      </WBButton>
      {(paymentMethod?.paymentMethodType === PaymentMethodType.CARD ||
        paymentMethod?.paymentMethodType === PaymentMethodType.APPLEPAY ||
        paymentMethod?.paymentMethodType === PaymentMethodType.GOOGLEPAY) && (
        <WBTypography
          textAlign="center"
          marginTop={0}
          fontWeight={400}
          color="grey"
        >
          Amount plus processing fee of 1.9% will be charged
        </WBTypography>
      )}
    </WBFlex>
  );
};
